import Script from "next/script";
import { useEffect } from "react";

import { prepReCAPTCHA, renderReCAPTCHA } from "./reCAPTCHAHandlers";

import { getConfig } from "src/common/config";

export { submitReCAPTCHA } from "./reCAPTCHAHandlers";

interface ReCAPTCHAProps {
  /**
   * A callback function for when the reCAPTCHA token is available or changed
   */
  tokenAvailable: (token: string) => void;
  /**
   * An optional id given to the html container for the CAPTCHA
   */
  containerId?: string;
}

const RECAPTCHA_URL = "https://www.recaptcha.net/recaptcha/api.js";
const RECAPTCHA_TOKEN_PREFIX = "v2gc>>";

/**
 * Use this component to add invisible reCAPTCHA to the page
 */
export const ReCAPTCHA = ({
  containerId = "recaptcha",
  tokenAvailable,
}: ReCAPTCHAProps) => {
  const reCAPTCHAInfo = getConfig().client.recaptcha;

  const updateToken = (token: string) => {
    tokenAvailable(RECAPTCHA_TOKEN_PREFIX + token);
  };

  const tokenError = () => {
    tokenAvailable(RECAPTCHA_TOKEN_PREFIX + "error_" + Date.now());
  };

  const render = () =>
    renderReCAPTCHA(containerId, reCAPTCHAInfo.v2Key, updateToken, tokenError);

  useEffect(() => {
    prepReCAPTCHA();
    render();
    // TODO: Fix exhaustive dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Script src={RECAPTCHA_URL} async />
      <div id={containerId} />
    </>
  );
};
